import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('jv-form-field')
export class JvFormField extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }
    *, *::before, *::after {
      box-sizing: border-box;
    }
    label {
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      font-size: var(--jv-fs-sm);
      color: var(--jv-color-muted);
      width: 100%;
    }
    .label {
      font-weight: var(--jv-fw-medium);
      color: var(--jv-color-text);
      text-transform: uppercase;
      font-size: var(--jv-fs-xs);
      letter-spacing: 0.03em;
    }
    input,
    select,
    textarea {
      width: 100%;
      max-width: 100%;
      min-height: 2.6rem;
      padding: 0.55rem 0.75rem;
      border: var(--jv-border-w) solid var(--jv-color-border);
      border-radius: var(--jv-radius);
      background: var(--jv-color-surface);
      color: var(--jv-color-text);
      font-family: var(--jv-font-body);
      font-size: 0.95rem;
    }
    input:focus,
    select:focus,
    textarea:focus {
      outline: 2px solid var(--jv-color-accent-soft);
      border-color: var(--jv-color-accent);
    }
    textarea {
      min-height: 5rem;
      resize: vertical;
    }
  `;

  @property() label = '';
  @property() name = '';
  @property() type = 'text';
  @property() value = '';
  @property() autocomplete = '';
  @property() placeholder = '';
  @property({ type: Boolean }) required = false;
  @property({ type: Boolean }) multiline = false;

  render() {
    return html`
      <label>
        <span class="label">${this.label}</span>
        ${this.multiline
          ? html`<textarea
              name=${this.name}
              placeholder=${this.placeholder}
              .value=${this.value}
              ?required=${this.required}
              @input=${this.onInput}
            ></textarea>`
          : html`<input
              name=${this.name}
              type=${this.type}
              placeholder=${this.placeholder}
              .value=${this.value}
              autocomplete=${this.autocomplete}
              ?required=${this.required}
              @input=${this.onInput}
            />`}
      </label>
    `;
  }

  private onInput(event: Event) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    this.value = target.value;
    this.dispatchEvent(
      new CustomEvent('jv-input', { detail: { name: this.name, value: this.value }, bubbles: true }),
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'jv-form-field': JvFormField;
  }
}
